import React from 'react';
import { SecretRow } from './SecretRow';
import type { SecretMetadata } from '@/api/useSecretsApi';

interface Props {
    secrets: SecretMetadata[];
    onEdit: (secret: SecretMetadata) => void;
    onDelete: (secret: SecretMetadata) => void;
    emptyMessage: string;
}

export const SecretsList: React.FC<Props> = ({ secrets, onEdit, onDelete, emptyMessage }) => {
    if (secrets.length === 0) {
        return <p className="text-sm text-neutral-500 dark:text-neutral-400 text-center py-6">{emptyMessage}</p>;
    }

    return (
        <div className="flex flex-col gap-0.5">
            {secrets.map(secret => (
                <SecretRow key={secret.id} secret={secret} onEdit={onEdit} onDelete={onDelete} />
            ))}
        </div>
    );
};
